import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "@environments/environment";
import { WebLogger } from "@weps/shared-http";
import { initializeTracing } from "./tracing";

// Initialize OpenTelemetry before Angular bootstraps
initializeTracing();


function importScript(url: string, scriptType?: string, async?: boolean): void {
  const script = document.createElement("script")
  script["src"] = url
  script["fetchpriority"] = "high"
  script["async"] = async? async : true
  if (scriptType) {
    script["type"] = scriptType
  }
  document.head.appendChild(script)
}

// Need to dynamically import script tag for vgn header
importScript(environment.vgnUrl)
//TODO: load Adobe C3 service dynamically.  We aren't pulling in the prod url :(

// Initialize WebLogger before bootstrapping Angular to ensure it's available
// for web-vitals callbacks and early logging
void WebLogger.init({
  environment: environment.logger_environment as "engineering" | "production" | "test",
  region: environment.internal ? "internal" : "external",
  isProduction: environment.production,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    WebLogger.log({ message: "Application bootstrap error", level: "error", payload: { error: err } });
  })
